const ColumnLayoutContainer = require("../common/ColumnLayoutContainer");
const Utils = require("../common/Utils");
const DefaultHeader = require("../common/DefaultHeader");
const postal = require("../common/PubSub");

function VFSLayoutContainer(navManager, element) {
    ColumnLayoutContainer.apply(this, [navManager, element, "vfs", element]);

    let currentResourceId;
    let initialNavIndex = -1;

    element.addClass("vfsContainer");

    let header = new DefaultHeader();
    element.closest("[data-role=page]").append(header.getContent());

    const $favButton = $('<a href="#" data-role="button" data-icon="mobile-favs" data-iconpos="notext" data-inline="true">');
    const $transferManagerButton = $('<a href="#" id="transferManagerButton" data-role="button" data-icon="mobile-filetransfers" data-iconpos="notext" data-inline="true">');
    const $closeButton = $('<a href="#" data-role="button" data-icon="mobile-close" data-iconpos="notext" data-inline="true">');
    const $refreshButton = $('<a href="#" id="vfsRefreshButton" data-role="button" data-icon="mobile-refresh" data-iconpos="notext" data-inline="true">');

    $closeButton.on("click", function() {
        if (CudaLaunch.NP) {
            window.close();
        } else {
            navManager.reset(initialNavIndex - 1, true);
            let view = navManager.getHistory().last();
            navManager.show(view, undefined, true);

            if (CudaLaunch.models && CudaLaunch.models.resources) {
                CudaLaunch.models.resources.refresh();
            }
        }
    });

    $favButton.on("click", function() {
        postal.channel("FavouritesController").publish("set-resource-favourite-state", {id : currentResourceId, state : $favButton.hasClass("selected")});
        $favButton.toggleClass("selected");
    });

    $transferManagerButton.on("click", function() {
        postal.channel("FileTransferManager").publish("show-file-transfer-dialog");
    });

    $refreshButton.on("click", function() {
        postal.channel("VFSController").publish("refresh-directory-list");
    });

    /**
     * @type {DefaultHeader~Configuration}
     */
    const headerConfig = {
        title : "",
        leftButtons : [$closeButton],
        rightButtons : [$refreshButton, $transferManagerButton, $favButton]
    };

    const super_show = this.show;
    this.show = function() {
        if (initialNavIndex < 0) {
            initialNavIndex = navManager.getCurrentIndex();
        }
        super_show.call(this);
        header.show();
    };

    const super_hide = this.hide;
    this.hide = function() {
        initialNavIndex = -1;
        super_hide.call(this);
        header.hide();
    };

    const super_resize = this.resize;
    this.resize = function(width, height) {
        super_resize.apply(this, [width, height - header.getContent().outerHeight()]);
    };

    postal.channel("VFSController").subscribe("launch-resource", function(data) {
        currentResourceId = data.vfsId;
        headerConfig.title = data.name;
        header.configure(headerConfig);
        $favButton.toggleClass("selected", data.favourite);
    });

    postal.channel("VFSController").subscribe("close-vfs", function() {
        $closeButton.trigger("click");
    });
}

Utils.inherits(VFSLayoutContainer, ColumnLayoutContainer);

module.exports = VFSLayoutContainer;